import ReactDOM from 'react-dom';
// import { ReactTagManager } from 'react-gtm-ts';
// import { setupIntegrations } from './utils/setupIntegrations';
import { Providers } from './components/Providers';
import { Layout } from './Layout';
import '../src/font.css';
import '../src/custom.css';
// import 'react-loading-skeleton/dist/skeleton.css';

// const tagManagerArgs = {
// 	code: 'GTM-WQVSH4L6',
// 	debug: true,
// 	performancE: false
// };
// ReactTagManager.init(tagManagerArgs);

// setupIntegrations();

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
	<Providers>
		<Layout />
	</Providers>,
	document.getElementById('root')
);
